import { NavLink, Outlet, Link } from 'react-router-dom';
import { useRole } from '../../lib/roleContext';

const contentItems = [
  { to: '/admin/layouts', label: 'Layouts' },
  { to: '/admin/families', label: 'Families' },
];

const adminItems = [
  { to: '/admin/products', label: 'Products' },
  { to: '/admin/snapshots', label: 'Price Snapshots' },
  { to: '/admin/users', label: 'User Roles' },
  { to: '/admin/shares', label: 'Share Links' },
  { to: '/admin/api-keys', label: 'API Keys' },
];

function NavItem({ to, label }: { to: string; label: string }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `flex items-center gap-2 px-4 py-2 text-sm transition-colors rounded-sm mx-1 ${
          isActive
            ? 'bg-white/15 text-white font-medium'
            : 'text-white/65 hover:bg-white/10 hover:text-white'
        }`
      }
    >
      {label}
    </NavLink>
  );
}

export function AdminLayout() {
  const { role } = useRole();

  return (
    <div className="flex h-full overflow-hidden">
      <aside className="w-52 shrink-0 bg-vari-navy text-white flex flex-col">
        <div className="px-4 py-4 border-b border-white/10">
          <p className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-1">Admin</p>
          <Link to="/" className="text-sm text-white/75 hover:text-white transition-colors">
            ← Back to gallery
          </Link>
        </div>

        <nav className="flex-1 py-3 overflow-y-auto space-y-4">
          <div>
            <p className="px-5 mb-1 text-[10px] font-semibold uppercase tracking-widest text-white/30">Content</p>
            {contentItems.map((item) => <NavItem key={item.to} {...item} />)}
          </div>

          {role === 'admin' && (
            <div>
              <p className="px-5 mb-1 text-[10px] font-semibold uppercase tracking-widest text-white/30">Admin</p>
              {adminItems.map((item) => <NavItem key={item.to} {...item} />)}
            </div>
          )}
        </nav>
      </aside>

      <main className="flex-1 overflow-y-auto bg-gray-50">
        <Outlet />
      </main>
    </div>
  );
}
